import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import StoreMenu from "../StoreMenu";
import { PostStoreUsers } from "../../services/StoreUsers/PostStoreUsers";
import { formatDate } from "../../constants/DateUtil/DateUtil";
import ButtonLink from "../../ButtonLink";

const StoreUser = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [storeUserData, setStoreUserData] = useState([]);

  const { storeData } = getUserData();

  const storeId = storeData.id;

  const fetchStoreUser = (data) => {
    PostStoreUsers(storeId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setStoreUserData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    const data = {
      storeId: storeId,
      status: "",
      roles: ["ROLE_RIDER", "ROLE_STORE", "ROLE_STORE_STAFF"],
    };
    fetchStoreUser(data);
  }, []);

  const renderCardItem = () => {
    return storeUserData?.map((item, index) => {
      const formattedCreatedDate =
        item.createdDate === null ? "" : formatDate(item.createdDate);
      const formattedNextRenewalDate =
        item.nextRenewalOn === null ? "" : formatDate(item.nextRenewalOn);
      const storeRole = item.role.replace(/_/g, " ");
      return (
        <div>
          <div className="flex-1">
            <div
              className="flex-1  surface-0"
              style={{ "--surface-0": "#EAEFF5" }}
            >
              <div className="flex justify-content-between mx-4">
                <div className="py-1">
                  <p className=" text-xl  font-bold ">
                    {item.firstName + " " + item.lastName}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    User Role :
                  </p>
                  <p className="text-lg font-medium capitalize">{storeRole}</p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Register On :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {formattedCreatedDate}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    User Id :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.userLoginId}
                  </p>
                </div>
              </div>
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Next Renewal Date :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {formattedNextRenewalDate}
                  </p>
                </div>

                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Account Status :
                  </p>
                  {item.enabled === true ? (
                    <div className="flex ">
                      <p className="text-lg font-medium capitalize mr-2">
                        Active{" "}
                      </p>
                      <img
                        src={
                          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                        }
                        style={{
                          height: 22,
                          width: 22,
                        }}
                      />
                    </div>
                  ) : (
                    <div className="flex ">
                      <p className="text-lg font-medium capitalize mr-2">
                        DeActive{" "}
                      </p>
                      <img
                        src={
                          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                        }
                        style={{
                          height: 22,
                          width: 22,
                        }}
                      />
                    </div>
                  )}
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Store User
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      {renderCardItem()}
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
    </div>
  );
};

export default StoreUser;
